class PremiumCustomFooter extends HTMLElement {
  connectedCallback() {
    this.classList.add('is-reveal-ready');
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.menus = [...this.querySelectorAll('[data-pcf-menu]')];
    this.form = this.querySelector('.pcf__signup');
    this.submit = this.querySelector('[data-pcf-submit]');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.mobileQuery.addEventListener('change', this.syncMenus);
    this.submit?.addEventListener('pointerdown', this.onSubmitPointerDown);
    this.form?.addEventListener('submit', this.onSubmit);
    this.syncMenus();
    this.setupReveal();
  }

  disconnectedCallback() {
    this.mobileQuery?.removeEventListener('change', this.syncMenus);
    this.submit?.removeEventListener('pointerdown', this.onSubmitPointerDown);
    this.form?.removeEventListener('submit', this.onSubmit);
    this.observer?.disconnect();
  }

  syncMenus = () => {
    if (!this.mobileQuery.matches) {
      this.menus.forEach((menu) => (menu.open = true));
      return;
    }

    this.menus.forEach((menu, index) => {
      menu.open = this.dataset.openFirstMobile === 'true' && index === 0;
    });
  };

  onSubmitPointerDown = (event) => {
    const ripple = this.submit?.querySelector('[data-pcf-ripple]');
    if (!ripple || this.reducedMotion.matches) return;
    const rect = this.submit.getBoundingClientRect();
    ripple.style.left = `${event.clientX - rect.left}px`;
    ripple.style.top = `${event.clientY - rect.top}px`;
    ripple.classList.remove('is-active');
    requestAnimationFrame(() => ripple.classList.add('is-active'));
    ripple.addEventListener('animationend', () => ripple.classList.remove('is-active'), { once: true });
  };

  onSubmit = () => {
    if (!this.form?.checkValidity()) return;
    this.form.classList.add('is-submitting');
    this.submit?.setAttribute('aria-busy', 'true');
  };

  setupReveal() {
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-revealed', 'is-in-view');
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-in-view', entry.isIntersecting);
        if (entry.isIntersecting) this.classList.add('is-revealed');
      },
      { rootMargin: '140px 0px', threshold: 0.03 }
    );
    this.observer.observe(this);
  }
}

if (!customElements.get('premium-custom-footer')) {
  customElements.define('premium-custom-footer', PremiumCustomFooter);
}
